export interface BrokerSession {
  session_id: string
  user_id: number
  user_email: string
  issued_at: string
  last_activity_at: string
  mfa_at: string
  source_ip: string
  user_agent: string | null
  active: boolean
  revoked_at: string | null
  revoked_reason: string | null
}

export async function listBrokerSessions(includeRevoked = false): Promise<{
  sessions: BrokerSession[]
  count: number
}> {
  const url = `/_broker/api/admin/sessions?include_revoked=${includeRevoked}`
  const r = await fetch(url, { credentials: 'include' })
  if (!r.ok) throw new Error(`list_sessions_failed:${r.status}`)
  return r.json()
}

export async function revokeBrokerSession(
  sessionId: string,
  reason: string,
): Promise<void> {
  const r = await fetch('/_broker/auth/revoke', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ session_id: sessionId, reason }),
  })
  if (!r.ok) throw new Error(`revoke_failed:${r.status}`)
}
